import { MandatorType } from "@rentablo/theming";
import { isComplianceProdHost } from "@mandatorFeatures/kpmg/complianceHost";

export type MandatorLoginConfigEntry = {
  mandator: MandatorType;
  showSSO: boolean;
};

export const MANDATOR_LOGIN_BY_SEGMENT: Record<
  string,
  MandatorLoginConfigEntry
> = {
  kpmg: { mandator: "kpmg-germany", showSSO: true },
};

export const MANDATOR_LOGIN_SEGMENT_MAP: Partial<Record<MandatorType, string>> =
  {
    "kpmg-germany": "kpmg",
  };

export const DEFAULT_LOGIN_PATH = "/login";

export function getLoginPathForMandator(slug: MandatorType): string | null {
  const segment = MANDATOR_LOGIN_SEGMENT_MAP[slug];
  return segment ? `/login/${segment}` : null;
}

export function getEnvDefaultLoginPath(): string | null {
  const raw = import.meta.env.VITE_DEFAULT_LOGIN_PATH?.trim();
  if (!raw || !raw.startsWith("/")) return null;
  return raw;
}

export function resolveLoginRedirectPath(
  slug: MandatorType,
  useEnvFallback: boolean
): string {
  const skipBranded = slug === "kpmg-germany" && !isComplianceProdHost();
  if (skipBranded) return DEFAULT_LOGIN_PATH;

  const branded = getLoginPathForMandator(slug);
  if (branded) return branded;

  if (useEnvFallback) {
    return getEnvDefaultLoginPath() ?? DEFAULT_LOGIN_PATH;
  }
  return DEFAULT_LOGIN_PATH;
}

export function showSSOForMandator(slug: MandatorType): boolean {
  return Object.values(MANDATOR_LOGIN_BY_SEGMENT).some(
    (entry) => entry.mandator === slug && entry.showSSO
  );
}
